import { createStore, applyMiddleware } from 'redux'
import { createBrowserHistory } from 'history'
import { createReduxHistoryContext } from 'redux-first-history'
import { thunk } from 'redux-thunk'

import { updateIntl } from '../intl/actions'
import { loadState, saveState } from '../localStorage/localStorage'
import createRootReducer from '../reducers'
import enTranslationMessages from '../../translation/en'
import newrelicMiddleware from '../errors/newrelic-middleware'

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
})

const configureStore = () => {
  const initialState = loadState()

  const middlewares = applyMiddleware(routerMiddleware, thunk, newrelicMiddleware)

  const store = createStore(createRootReducer(routerReducer), initialState, middlewares)

  store.dispatch(updateIntl(enTranslationMessages))

  store.subscribe(() => {
    saveState(store.getState())
  })

  return store
}

export const store = configureStore()
export const history = createReduxHistory(store)
export default store
